// components/Footer.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import '../styles/NavbarFooter.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} Il Rialto. Tous droits réservés.</p>
      <div className="social-icons">
        <a
          href="https://www.facebook.com/ilrialtoknokke/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faFacebook} size="2x" />
        </a>
        <a
          href="https://www.instagram.com/ilrialto_knokke/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faInstagram} size="2x" />
        </a>
       
      </div>
      <p className="footer-text">make by DesmTech</p>
    </footer>
  );
};

export default Footer;
